module.exports = __webpack_public_path__ + "static/media/24UHCHR23.10a373e6.jpg";